module.exports = __webpack_public_path__ + "static/media/logo-white.a703c0bb.svg";